import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Grid, List, Box } from '@material-ui/core'
import PageMetaData from '@v4/utils/data/PageMetaData'
import Image from '@v4/components/common/Image'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import SortHandler from '@v4/components/common/SortHandler'
import EditableContainer from '@v4/components/common/EditableContainer'
import EditableHTML from '@v4/components/common/EditableHTML'
import Item from './components/Item'
import { CONTENT_WIDTH } from './Cta16_17.const'
// eslint-disable-next-line camelcase
import { useCta16_17 } from './Cta16_17.hooks'

// eslint-disable-next-line camelcase
const Cta16_17 = props => {
	const [
		{
			classes,
			items,
			contentWidth,
			isMobile,
			direction,
			image,
			withBgImage,
			withImageCenter,
			withTopContent,
			withMobileImage,

			title,
			titleConfig,
			titleKey,
			titleEditable,

			text,
			textConfig,
			textKey,
			textEditable,

			buttonText,
			buttonTextConfig,
			buttonTextKey,
			buttonAction,
			buttonLink,
			buttonTextEditable,

			additionalText,
			additionalTextConfig,
			additionalTextKey,
			additionalTextEditable,
		},
		{
			handleTitleClick,
			handleTitleChange,
			handleImageClick,
			handleTextChange,
			handleTextClick,
			handleButtonClick,
			handleButtonTextChange,
			handleAdditionalTextClick,
			handleAdditionalTextChange,
		},
	] = useCta16_17(props)

	return (
		<div className="cta16_17-root">
			{withBgImage && (
				<Image className={clsx(classes.bgImage, 'cta16_17-bg-image')} metaData={image} isBackground />
			)}
			<Grid container className={clsx(classes.root, 'cta16_17-grid')}>
				<SortHandler key={isMobile ? 'mobile' : 'desktop'} direction={direction}>
					<Grid
						item
						xs={12}
						sm={12}
						md={CONTENT_WIDTH[contentWidth]}
						className={clsx(classes.gridItem, 'cta16_17-grid-item')}
					>
						<Box className={clsx(classes.container, 'cta16_17-container')}>
							{withTopContent && (
								<>
									<EditableContainer
										visible={!!title}
										fieldConfig={titleConfig}
										onAdd={handleTitleChange}
										editable={titleEditable}
										white={withBgImage}
									>
										<EditableHTML
											className={clsx(classes.title, 'cta16_17-title')}
											html={title}
											onClick={handleTitleClick}
											editable={titleEditable}
											onChange={handleTitleChange}
											white={withBgImage}
											key={titleKey}
										/>
									</EditableContainer>
									{withImageCenter && (
										<Image
											className={clsx(classes.image, 'cta16_17-image')}
											metaData={image}
											onClick={handleImageClick}
										/>
									)}
									<EditableContainer
										visible={!!text}
										fieldConfig={textConfig}
										onAdd={handleTextChange}
										editable={textEditable}
										white={withBgImage}
									>
										<EditableHTML
											className={clsx(classes.text, 'cta16_17-text')}
											html={text}
											onClick={handleTextClick}
											editable={textEditable}
											onChange={handleTextChange}
											white={withBgImage}
											key={textKey}
										/>
									</EditableContainer>
								</>
							)}
							{withMobileImage && (
								<Image
									className={clsx(classes.image, 'cta16_17-image')}
									metaData={image}
									onClick={handleImageClick}
								/>
							)}
						</Box>
					</Grid>

					{!_.isEmpty(items) && (
						<List className={clsx(classes.list, 'cta16_17-list')}>
							{_.map(items, (key, index) => (
								<Item key={key} itemKey={key} group="items" index={index} />
							))}
						</List>
					)}
					<Grid
						item
						xs={12}
						sm={12}
						md={CONTENT_WIDTH[contentWidth]}
						className={clsx(classes.gridItem, 'cta16_17-grid-item')}
					>
						<Box className={clsx(classes.container, 'cta16_17-container')}>
							{!withTopContent && (
								<>
									<EditableContainer
										visible={!!title}
										fieldConfig={titleConfig}
										onAdd={handleTitleChange}
										editable={titleEditable}
										white={withBgImage}
									>
										<EditableHTML
											className={clsx(classes.title, 'cta16_17-title')}
											html={title}
											onClick={handleTitleClick}
											editable={titleEditable}
											onChange={handleTitleChange}
											white={withBgImage}
											key={titleKey}
										/>
									</EditableContainer>
									<EditableContainer
										visible={!!text}
										fieldConfig={textConfig}
										onAdd={handleTextChange}
										editable={textEditable}
										white={withBgImage}
									>
										<EditableHTML
											className={clsx(classes.text, 'cta16_17-text')}
											html={text}
											onClick={handleTextClick}
											editable={textEditable}
											onChange={handleTextChange}
											white={withBgImage}
											key={textKey}
										/>
									</EditableContainer>
								</>
							)}
							<EditableContainer
								visible={!!buttonText}
								fieldConfig={buttonTextConfig}
								onAdd={handleButtonTextChange}
								editable={buttonTextEditable}
								label="Button"
								wrapper={({ children }) => (
									<Box width="100%" className={clsx(classes.buttonWrap, 'cta16_17-button-wrapper')}>
										{children}
									</Box>
								)}
							>
								<ActionButton
									key={buttonTextKey}
									className={clsx(classes.button, 'cta16_17-button')}
									editable={buttonTextEditable}
									onClick={handleButtonClick}
									onChange={handleButtonTextChange}
									action={buttonAction}
									href={buttonLink}
								>
									{buttonText}
								</ActionButton>
							</EditableContainer>

							<EditableContainer
								visible={!!additionalText}
								fieldConfig={additionalTextConfig}
								onAdd={handleAdditionalTextChange}
								editable={additionalTextEditable}
								white={withBgImage}
							>
								<EditableHTML
									className={clsx(classes.text, 'cta16_17-additional-text')}
									html={additionalText}
									onClick={handleAdditionalTextClick}
									editable={additionalTextEditable}
									onChange={handleAdditionalTextChange}
									white={withBgImage}
									key={additionalTextKey}
								/>
							</EditableContainer>
						</Box>
					</Grid>
				</SortHandler>
			</Grid>
		</div>
	)
}

Cta16_17.propTypes = {
	metaData: PropTypes.shape({
		title: PropTypes.instanceOf(PageMetaData),
		image: PropTypes.instanceOf(PageMetaData),
		text: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		additionalText: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Cta16_17)
